import numbro from "numbro";
import * as XLSX from "xlsx";

function extractNumbers(inputString) {
  let outputString = "";
  for (let i = 0; i < inputString.length; i++) {
    if (!isNaN(inputString[i]) || inputString[i] === "." || inputString[i] === "-") {
      outputString += inputString[i];
    }
  }
  return Number(outputString);
}

function updateCellsBasedOnPattern({ worksheet, colName, type, pattern, fileType }) {
  let count = 1;

  while (worksheet[colName + count]) {
    const key = colName + count;
    const value = worksheet[key];

    if (count > 1) {
      worksheet[key] = xlsxFormat[type](value, pattern, fileType);
    }
    count++;
  }
}

const xlsxFormat = {
  percentage: (value, pattern) =>
    isNaN(value.v)
      ? { t: "s", v: value.v }
      : {
          t: "n",
          v: value.v,
          z: pattern
        },
  currency: (value, pattern) => ({
    t: "n",
    v: typeof value.v === "string" ? extractNumbers(value.v) : value.v,
    z: pattern
  }),
  number: (value, pattern, fileType) => {
    if (fileType === "csv") {
      return { t: "s", v: numbro(value.v).format({ thousandSeparated: true }) };
    } else {
      return isNaN(value.v)
        ? { t: "s", v: value.v }
        : {
            t: "n",
            v: value.v,
            z: pattern
          };
    }
  }
};

function formatColumns(columns, worksheet, fileType) {
  const currencyColNames = columns?.reduce((acc, col, index) => {
    if (Object.keys(xlsxFormat).includes(col.xlsxFormat)) {
      acc.push({ name: XLSX.utils.encode_col(index), index });
    }
    return acc;
  }, []);

  if (currencyColNames?.length) {
    currencyColNames.forEach((currencyCol) => {
      updateCellsBasedOnPattern({
        worksheet,
        colName: currencyCol.name,
        type: columns[currencyCol.index].xlsxFormat,
        pattern:
          columns[currencyCol.index].numericFormat?.currencyPattern ??
          columns[currencyCol.index].pattern,
        fileType
      });
    });
  }
}

export function xlsxExport({
  data,
  headers,
  fileName,
  dataStructure = "aoa",
  fileType = "xlsx",
  download,
  columns = []
}) {
  let worksheet;

  const tableData = [...data];

  if (!download && tableData.length === 0) return -1;
  switch (dataStructure) {
    case "aoa":
      tableData.unshift(headers);
      worksheet = XLSX.utils.aoa_to_sheet(tableData);
      break;
    case "jts":
      worksheet = XLSX.utils.json_to_sheet(tableData);
      break;
    default:
      break;
  }

  // formatCurrencyColumns(columns, worksheet);
  formatColumns(columns, worksheet, fileType);
  worksheet["!cols"] = fitToColumn(tableData, dataStructure);
  const workbook = XLSX.utils.book_new();
  const safeSheetName = String(fileName).replace(/[\\/:*?\\[\]]/g, "").slice(0, 31) || "Sheet1";
  XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName);
  XLSX.writeFile(workbook, `${fileName}.${fileType}`);
}

function findMaxCharLength(arr, column) {
  let max = 0;
  for (let i = 0; i < arr.length; i++) {
    let cell = arr[i][column] ? arr[i][column].toString().length : 0;
    max = Math.max(cell, max);
  }
  return max;
}

function fitToColumn(data, dataStructure = "aoa") {
  let res = [];

  // get maximum character of each column
  switch (dataStructure) {
    case "aoa":
      res = data[0].map((a, i) => ({
        wch: findMaxCharLength(data, i)
      }));
      break;
    case "jts":
      for (const property in data[0]) {
        res.push({
          wch: Math.max(property.length, findMaxCharLength(data, property))
        });
      }
      break;
    default:
      break;
  }

  return res;
}
